export const INPUT_FULL_WIDTH_FROM = 700;
export const DEFAULT_MIN_INPUT_WIDTH = 480;
